import type { SubmitPayload } from "./types";

// Integral coverage: none, 1MM or 2MM (the Contract entity's INTEGRAL_AMOUNTS,
// as the submit input types them). It does not affect the price. The merchant
// picks one per current fianza; by now every inducted contract gets the
// highest one. Options are ascending.
export type IntegralCoverage = SubmitPayload["items"][number]["integralAmount"];

export const INTEGRAL_COVERAGE_OPTIONS: readonly {
  amount: IntegralCoverage;
  label: string;
}[] = [
  { amount: undefined, label: "Sin" },
  { amount: 1_000_000, label: "1MM" },
  { amount: 2_000_000, label: "2MM" },
];

export const DEFAULT_INTEGRAL_COVERAGE: IntegralCoverage = 1_000_000;

const optionOf = (coverage: IntegralCoverage) =>
  INTEGRAL_COVERAGE_OPTIONS.find((option) => option.amount === coverage);

export const integralCoverageLabel = (coverage: IntegralCoverage): string =>
  optionOf(coverage)?.label ?? "";

// What a <select> carries for a coverage, and back.
export const integralCoverageValue = (coverage: IntegralCoverage): string =>
  String(coverage ?? 0);

export const parseIntegralCoverage = (value: string): IntegralCoverage =>
  INTEGRAL_COVERAGE_OPTIONS.find(
    (option) => integralCoverageValue(option.amount) === value
  )?.amount;

const rank = (coverage: IntegralCoverage) =>
  INTEGRAL_COVERAGE_OPTIONS.findIndex((option) => option.amount === coverage);

export const highestIntegralCoverage = (
  coverages: IntegralCoverage[]
): IntegralCoverage =>
  coverages.reduce(
    (highest, coverage) =>
      rank(coverage) > rank(highest) ? coverage : highest,
    coverages[0] ?? DEFAULT_INTEGRAL_COVERAGE
  );
